import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from '@ebw-monorepo/login';
import { Observable } from 'rxjs';
import { API_URLS, ApiUrlService } from '../../../../utils/src/lib/services/api-url.service';
import {
  CodiciSuperamentiResponse,
  ParametriAnaliticiResponse,
  PrelievoInput,
  SuperamentoInput,
  ValidazionePrelieviResponse,
  ValidazioneSuperamentiResponse
} from '../models/controlli.model';

/**
 * Servizio per il caricamento, validazione e salvataggio dei dati "Controlli"
 * del PSA (prelievi/controlli analitici e superamenti Reportnet3).
 */
@Injectable({
  providedIn: 'root'
})
export class ControlliService {
  constructor(
    private _http: HttpClient,
    private _loginService: LoginService,
    private _apiUrlService: ApiUrlService
  ) {}

  get _headers(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this._loginService.getToken()
    });
  }

  // ------------------------------------------------------------------------------------------------

  public validatePrelievi(file: File): Observable<ValidazionePrelieviResponse> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.PRELIEVI_VALIDA);
    const body = new FormData();
    body.append('file', file);
    const headers = { headers: this._headers };
    return this._http.post<ValidazionePrelieviResponse>(url, body, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public savePrelievi(righe: PrelievoInput[]): Observable<{ message: string; count: number }> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.PRELIEVI);
    const headers = { headers: this._headers };
    return this._http.post<{ message: string; count: number }>(url, { righe }, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public validateSuperamenti(file: File): Observable<ValidazioneSuperamentiResponse> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.SUPERAMENTI_VALIDA);
    const body = new FormData();
    body.append('file', file);
    const headers = { headers: this._headers };
    return this._http.post<ValidazioneSuperamentiResponse>(url, body, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public saveSuperamenti(righe: SuperamentoInput[]): Observable<{ message: string; count: number }> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.SUPERAMENTI);
    const headers = { headers: this._headers };
    return this._http.post<{ message: string; count: number }>(url, { righe }, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public getParametriAnalitici(): Observable<ParametriAnaliticiResponse> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.PARAMETRI_ANALITICI);
    const headers = { headers: this._headers };
    return this._http.get<ParametriAnaliticiResponse>(url, headers);
  }

  // ------------------------------------------------------------------------------------------------

  public getCodiciSuperamenti(): Observable<CodiciSuperamentiResponse> {
    const url = this._apiUrlService.createUrl(API_URLS.CONTROLLI.SUPERAMENTI_CODICI);
    const headers = { headers: this._headers };
    return this._http.get<CodiciSuperamentiResponse>(url, headers);
  }
}
